import { Fragment, PropsWithChildren } from 'react';

import DeprecatedLayout from '@/components/_deprecated/template/Layout';
import UiVersionSwitcher from '@/components/ui/custom/UiVersionSwitcher';

type LayoutProps = PropsWithChildren<{
  className?: string;
  privated?: boolean;
}>;

export default function Layout(props: LayoutProps) {
  return (
    <UiVersionSwitcher scope="appShell">
      <UiVersionSwitcher.Legacy>
        <DeprecatedLayout {...props} />
      </UiVersionSwitcher.Legacy>
      <UiVersionSwitcher.Modern>
        <Fragment>{props.children}</Fragment>
      </UiVersionSwitcher.Modern>
    </UiVersionSwitcher>
  );
}
